<template>
  <img :src="schemeIcon" alt="scheme icon" :height="height" :width="width" />
</template>

<script>
export default {
  name: "SchemeIcon",
  props: {
    scheme: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      default: "24",
    },
    height: {
      type: String,
      default: "24",
    },
  },
  computed: {
    schemeToLowerCase() {
      return this.scheme?.toLowerCase();
    },
    schemeIcon() {
      const ICONS_SRC_URL = {
        asistencias: require("@/assets/icons/asistencias.svg"),
        asistencia: require("@/assets/icons/asistencias.svg"),
        siniestros: require("@/assets/icons/siniestros.svg"),
        reintegro: require("@/assets/icons/reintegro.svg"),
        fletes: require("@/assets/icons/fletes.png"),
        inmobiliaria: require("@/assets/icons/inmobiliaria.png"),
        corpo: require("@/assets/icons/corporativo.png"),
        "cliente-final": require("@/assets/icons/clientefinal.png"),
        liquidacion: require("@/assets/icons/siniestros.svg"),
      };
      console.log(this.schemeToLowerCase);

      return (
        ICONS_SRC_URL[this.schemeToLowerCase] || ICONS_SRC_URL["asistencias"]
      );
    },
  },
};
</script>

<style scoped>
img {
  display: block;
  flex-shrink: 0;
  object-fit: contain;
  object-position: center;
}
</style>
